import { useMutation } from '@tanstack/react-query'
import { inventoryApi } from '../../api/inventoryApi'
import { toast } from '@/integrations/toaster-provider'

export const useDownloadInvoiceMutation = () => {
  return useMutation({
    mutationFn: async (transactionId: string) => {
      const response = await inventoryApi.downloadInvoice(transactionId)
      return response.data
    },
    onError: (error: any) => {
      toast.error(
        `Failed to download invoice: ${error?.message || 'Unknown error'}`,
      )
      console.error('Failed to download invoice:', error)
    },
  })
}
